import { useCallback } from "react";
import { useAppSelector } from "./useAppSelector";

export const useAttendanceRecordsHook = () => {
  const { lastCollaboratorAttendanceRecord } = useAppSelector(
    (state) => state.attendanceRecordsReducer
  );

  const { branches } = useAppSelector((state) => state.branches);

  const getLastRecordBranch = () => {
    const lastRecordBranch = branches.find(
      (branch) => branch.id === lastCollaboratorAttendanceRecord?.clockInBranch
    );

    if (!lastRecordBranch) {
      return branches.find((branch) => branch.name.toLowerCase() === "urban");
    }

    return lastRecordBranch;
  };

  const getLastRecordBranchName = useCallback(() => {
    const lastRecordBranch = getLastRecordBranch()!;
    return lastRecordBranch?.name;
  }, [getLastRecordBranch]);

  const isCurrentlyWorking = () => {
    const exitTime = lastCollaboratorAttendanceRecord?.endTime;

    if (!exitTime) {
      return true;
    }

    return false;
  };

  const lastRecordBranchName = getLastRecordBranchName();
  const lastRecordBranchId = getLastRecordBranch()?.id;

  return {
    getLastRecordBranch,
    getLastRecordBranchName,
    lastRecordBranchName,
    lastRecordBranchId,
    isCurrentlyWorking,
  };
};
